import axios from 'axios';

export async function postRequest(jsonWebToken, url, data){
    let headersList
    if(jsonWebToken){
        headersList = {
            "Authorization": "bearer " + jsonWebToken,
            "Content-Type": "application/x-www-form-urlencoded" 
        }
    } 
    let reqOptions = {
        url: url,
        method: "POST",
        headers: headersList && headersList,
        data: data,
    }  
    let response = await axios.request(reqOptions);
    return response

}

export function getRequest(){
    
}


export function checkImage(path) {
    console.log("--------------")
    console.log(path)
    axios
      .get(path)
      .then(() => {
        return true;
      })
      .catch((error) => {
        console.log("checkImage ERROR:")
        console.log(error)
        return false;
      });
  }






